import { appConfig as $config } from '../../app.config';
import { User } from '../User';

const licensorFilterInternalName = 'Licensor';

export const QuickFilters = (function () {
  let $page, $syncFilters, $licensorFilters, $licenseeFilters;

  let init = ({ selector = false, pagename = false } = {}) => {
    if (!selector) return;

    $page = pagename ? pagename : document.location.pathname.split('/')[1] || $config.default.page;
    $page = $page.toLowerCase();

    let filterdata = $storage.get('filterdata_' + $page) || {};

    $syncFilters = QuickFilters.getSyncFilters($page);

    const filters = !$syncFilters?.length
      ? []
      : $syncFilters.map((sf) => (filterdata.filterItems || []).find((f) => f.internalName === sf)).filter(Boolean);

    let template = require(`./tmpl/quick-filters.hbs`);

    $(selector)
      .empty()
      .html(
        template({
          filters,
          requestPage: $page
        })
      );
  };

  let update = (page) => {
    storeLicensors(page);
  };

  let storeLicensors = (page) => {
    if (!$syncFilters || page !== $page) {
      return;
    }

    const filterspage = $storage.get('filterspage_' + page) || [];

    const syncedFilters = filterspage.filter((f) => $syncFilters.includes(f.internalName));
    $storage.set($config.storagekey.syncedFilters, syncedFilters);

    const licensorsFilter = filterspage.find((f) => f.internalName === licensorFilterInternalName);
    if (!licensorsFilter) {
      User.setLicensorsId([]);
    } else {
      User.setLicensorsId((licensorsFilter.values || []).map((v) => v.value));
    }
  };

  let getSyncFilters = (page) => {
    if (page !== $page) {
      return [];
    }

    return (User.isLicensor() ? $licensorFilters : $licenseeFilters) || [];
  };

  let setSyncFilters = ({ licensorFilters = [], licenseeFilters = [] }) => {
    $licensorFilters = licensorFilters;
    $licenseeFilters = licenseeFilters;
    $page = document.location.pathname.split('/')[1] || $config.default.page;
  };

  return {
    init,
    update,
    getSyncFilters,
    setSyncFilters
  };
})();

export const setStoredLicensorsToFilter = (page) => {
  let licensorPrefilledFilter = $storage.get($config.storagekey.syncedFilters) || [];
  let filtersgpage = $storage.get('filterspage_' + page) || [];

  const syncFilters = QuickFilters.getSyncFilters(page);

  filtersgpage = filtersgpage.filter((f) => !(syncFilters || []).includes(f.internalName));
  licensorPrefilledFilter = licensorPrefilledFilter.filter((f) => (syncFilters || []).includes(f.internalName))

  const result = [...filtersgpage, ...licensorPrefilledFilter];

  $storage.set('filterspage_' + page, result);

  return result;
};
